import type { SVGProps } from 'react';

interface SelectChevronIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export function SelectChevronIcon({ className, ...props }: SelectChevronIconProps) {
  return (
    <svg
      width="12"
      height="7"
      viewBox="0 0 12 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
      {...props}
    >
      <path
        d="M6 6.66669L0.521506 1.3989C0.239908 1.12814 0.2477 0.675162 0.538443 0.414239C0.799134 0.180285 1.1958 0.185778 1.44991 0.42686L6 4.74361L10.5501 0.426861C10.8042 0.185779 11.2009 0.180286 11.4616 0.41424C11.7523 0.675163 11.7601 1.12814 11.4785 1.3989L6 6.66669Z"
        fill="currentColor"
      />
    </svg>
  );
}
